/**
 * Spanish for Stytch's prebuilt B2B login (message ids from @stytch/vanilla-js 6.x; placeholders
 * in {braces}). Ids not listed stay in English until someone translates them.
 */
export const SPANISH: Record<string, string> = {
  'login.title': 'Entra o regístrate',
  'login.loading': 'Entrando…',
  'login.success.content': 'Entraste correctamente.',
  'button.continue': 'Continuar',
  'button.continueWithEmail': 'Continuar con correo',
  'button.emailCode': 'Enviarme un código',
  'button.emailLink': 'Enviarme un enlace',
  'button.goBack': 'Regresar',
  'button.resendEmail': 'Reenviar correo',
  'button.retry': 'Intentar de nuevo',
  'button.tryDifferentEmailAddress': 'Usar otro correo',
  'formField.email.label': 'Correo',
  'formField.email.placeholder': 'tu@agencia.com',
  'emailMethodSelection.title': '¿Cómo quieres continuar?',
  'emailMethodSelection.code': 'Enviarme un código de acceso',
  'emailMethodSelection.link': 'Enviarme un enlace de acceso',
  'emailConfirmation.title': 'Revisa tu correo',
  'emailConfirmation.content': 'Enviamos un correo a <bold>{email}</bold>.',
  'emailConfirmation.emailSent': '¡Correo enviado! Puedes reintentar en {timeRemaining} s',
  'passcode.title': 'Escribe el código',
  'passcode.resendCode': 'Reenviar código',
  'passcode.codeSent': '¡Código enviado! Puedes reintentar en {timeRemaining} s',
  'organizationDiscovery.title': 'Elige tu agencia',
  'organizationLogin.title': 'Continuar a {organizationName}',
  'error.title': 'Algo salió mal',
  'error.emailNotFound': 'No encontramos ese correo.',
  'loading.label': 'Cargando',
  'error.default': 'Algo falló al entrar. Intenta de nuevo; si sigue pasando, avisa a tu agencia.',
  'error.eml': 'Tu enlace de acceso venció o ya se usó. Pide uno nuevo.',
  'error.unableToAuthMagicLink': 'Tu enlace de acceso venció o ya se usó. Pide uno nuevo.',
  'error.otpCodeNotFound': 'El código no es válido. Revisa e intenta de nuevo.',
  'error.passcodeInvalid': 'El código no es válido. Revisa e intenta de nuevo.',
  'error.invalidCode': 'El código tiene un formato inválido.',
  'error.invalidEmail': 'El correo no tiene un formato válido.',
  'error.invalidEmailAddress': 'Correo inválido.',
  'error.organization': 'No encontramos esa agencia. Si crees que es un error, avisa a tu agencia.',
  'error.inactiveEmail': 'Ese correo está desactivado. Usa otro o avisa a tu agencia.',
  'error.userLockLimitReached':
    'Demasiados intentos fallidos. Espera unos minutos e intenta de nuevo.',
  'error.adBlockerDetected':
    'Un bloqueador de anuncios detuvo la solicitud. Desactívalo para Nubi y recarga la página.',
  'error.sessionNotFound': 'Tu sesión terminó. Vuelve a entrar.',
  'organizationDiscovery.join': 'Entrar',
  'organizationDiscovery.acceptInvite': 'Aceptar invitación',
  'organizationDiscovery.noOrgs.content':
    'Revisa que el correo esté bien escrito. Si lo está, pide a tu agencia que te registre.',
  // Google (features/identity-access/metodos-de-acceso.feature).
  'oauth.continueWithGoogle': 'Continuar con Google',
  'provider.continueWith': 'Continuar con {display_name}',
  'provider.continueWithSSO': 'Usar el acceso de tu empresa (SSO)',
  'provider.lastUsed': 'Último usado',
  'methodDivider.text': 'o',
  'error.oauthFlowCallbackError': 'No pudimos terminar el acceso con Google. Intenta de nuevo.',
  'error.oauthTokenNotFound': 'El acceso con Google venció. Intenta de nuevo.',
  'emailVerification.title': 'Confirma tu correo',
  'emailVerification.content': 'Confirma tu correo con una de estas opciones:',
  // Email + password: Stytch keeps and checks the password (strength and breach detection).
  'button.usePassword': 'Entrar con contraseña',
  'button.loginWithoutPassword': 'Entrar sin contraseña',
  'button.showPassword': 'Mostrar',
  'button.hidePassword': 'Ocultar',
  'button.emailResent': '¡Correo reenviado! Puedes reintentar en {timeRemaining} s',
  'button.createAnOrganization': 'Crear una organización',
  'button.totpQrManual': '¿No puedes escanear el código?',
  'button.totpQrRetry': 'Escanear el código QR otra vez',
  'formField.password.label': 'Contraseña',
  'link.signupResetPassword': 'Crear o restablecer contraseña',
  'password.login.title': 'Entra con tu correo y contraseña',
  'password.forgot.title': 'Revisa tu correo',
  'password.forgot.content.discovery':
    'Te enviaremos un enlace para crear tu contraseña o restablecerla si ya tienes una.',
  'password.forgot.content.organization':
    'Te enviaremos un enlace para entrar directamente o restablecer tu contraseña si ya tienes una.',
  'password.reset.emailSent.title': 'Revisa tu correo',
  'password.reset.emailSent.content': 'Enviamos un enlace a <bold>{email}</bold>.',
  'password.verification.title': 'Primero confirma tu correo',
  'password.verification.content': 'Enviamos un enlace a <bold>{email}</bold>.',
  'password.setNew.title': 'Crea una contraseña nueva',
  'password.strength': 'Fuerza de la contraseña: {score} de 4.',
  'password.strength.accepted': 'Contraseña aceptada.',
  'password.strength.notAccepted': 'Contraseña no aceptada.',
  'password.strength.requirementsNotMet': 'La contraseña debe cumplir todos los requisitos.',
  'password.requirement.fulfilled': 'Cumplido',
  'password.requirement.notFulfilled': 'Pendiente',
  'password.requirement.suggestion': 'Sugerencia',
  'password.requirement.warning': 'Advertencia',
  'password.strengthError.breached':
    'Esta contraseña apareció en una filtración de otro sitio. Elige otra.',
  'password.strengthError.complexity':
    '{complexity, plural, one {Debe tener # de estos: mayúscula, minúscula, número, símbolo} other {Debe tener # de estos: mayúscula, minúscula, número, símbolo}}',
  'password.strengthError.minimumLength':
    '{characterLength, plural, one {Debe tener al menos # carácter} other {Debe tener al menos # caracteres}}',
  'password.zxcvbn.suggestion.addWords':
    'Agrega una o dos palabras más; mejor si son poco comunes.',
  'password.zxcvbn.suggestion.allUppercase':
    'Todo en mayúsculas es casi tan fácil de adivinar como todo en minúsculas.',
  'password.zxcvbn.suggestion.avoidDatesAndYearsAssociatedWithYou':
    'Evita fechas y años relacionados contigo.',
  'password.zxcvbn.suggestion.avoidRecentYears': 'Evita años recientes.',
  'password.zxcvbn.suggestion.avoidRepeats': 'Evita palabras y caracteres repetidos.',
  'password.zxcvbn.suggestion.avoidSequences': 'Evita secuencias.',
  'password.zxcvbn.suggestion.avoidYearsAssociatedWithYou': 'Evita años relacionados contigo.',
  'password.zxcvbn.suggestion.capitalization': 'Las mayúsculas no ayudan mucho.',
  'password.zxcvbn.suggestion.longerKeyboardPattern':
    'Usa un patrón de teclado más largo y con más giros.',
  'password.zxcvbn.suggestion.noSymbolsDigitsUppercase':
    'No hacen falta símbolos, números ni mayúsculas.',
  'password.zxcvbn.suggestion.predictableSubstitutions':
    "Cambios previsibles como '@' en lugar de 'a' no ayudan mucho.",
  'password.zxcvbn.suggestion.reversed': 'Las palabras al revés no son mucho más difíciles.',
  'password.zxcvbn.suggestion.useAFewWords': 'Usa varias palabras y evita frases comunes.',
  'password.zxcvbn.warning.commonNames': 'Los nombres y apellidos comunes son fáciles de adivinar.',
  'password.zxcvbn.warning.dates': 'Las fechas suelen ser fáciles de adivinar.',
  'password.zxcvbn.warning.longerRepeats':
    'Repeticiones como "abcabcabc" son apenas más difíciles que "abc".',
  'password.zxcvbn.warning.names': 'Un nombre o apellido solo es fácil de adivinar.',
  'password.zxcvbn.warning.recentYears': 'Los años recientes son fáciles de adivinar.',
  'password.zxcvbn.warning.repeats': 'Repeticiones como "aaa" son fáciles de adivinar.',
  'password.zxcvbn.warning.sequences': 'Secuencias como "abc" o "6543" son fáciles de adivinar.',
  'password.zxcvbn.warning.shortKeyboardPatterns':
    'Los patrones cortos de teclado son fáciles de adivinar.',
  'password.zxcvbn.warning.similarToCommonPassword': 'Se parece a una contraseña muy usada.',
  'password.zxcvbn.warning.straightRows': 'Las filas seguidas del teclado son fáciles de adivinar.',
  'password.zxcvbn.warning.top100CommonPassword': 'Es una de las 100 contraseñas más usadas.',
  'password.zxcvbn.warning.top10CommonPassword': 'Es una de las 10 contraseñas más usadas.',
  'password.zxcvbn.warning.veryCommonPassword': 'Es una contraseña muy usada.',
  'password.zxcvbn.warning.wordByItself': 'Una palabra sola es fácil de adivinar.',
  'error.breachedPassword':
    'Tu contraseña apareció en una filtración de otro sitio. Restablécela para entrar.',
  'error.resetPassword': 'Debes restablecer tu contraseña para entrar.',
  'error.memberPasswordNotFound':
    'Aún no tienes contraseña. Usa «Crear o restablecer contraseña» o entra sin contraseña.',
  'error.noUserPassword':
    'Correo o contraseña incorrectos. Revisa e intenta de nuevo, o entra sin contraseña.',
  'error.unauthorizedCredentials': 'Correo o contraseña incorrectos. Revisa e intenta de nuevo.',
  'error.authPolicyNoOrg':
    'La política de acceso de la agencia no permite este método. Usa otro o avisa a tu agencia.',
  'error.authPolicyWithOrg':
    'La política de acceso de {organizationName} no permite este método. Usa otro o avisa a tu agencia.',
  'error.emailNoAccessToOrg':
    '{email} no tiene acceso a {organizationName}. Si crees que es un error, avisa a tu agencia.',
};
